export default __webpack_public_path__ + "static/media/p.556c1534.png";